import Typed from "react-typed";
import {
    decodeStyle,
    isHidden,
    mobile,
    parseStyle,
    tablet,
} from "../../../../juntion";
import log from "cslog";
import { Fragment } from "react";

function Breadcrumb({ id, db, device, gs }) {
    const data = db[id];

    const ps = parseStyle(data, gs, data.cstate);

    let input = ps.input;
    input = { ...input, ...(tablet(device) && ps.itablet) };
    input = { ...input, ...(mobile(device) && ps.imobile) };

    const linkStyle = {
        cursor: "pointer",
    };

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
            }}
        >
            {input.breadcrumbItems.length > 0 && (
                <div
                    style={{
                        display: "flex",
                        gap: input.gap,
                        fontSize: input.fontSize || "12px",
                        ...decodeStyle(ps.fixStyle, gs),
                        ...decodeStyle(ps.style, gs),
                        ...(tablet(device) && decodeStyle(ps.tablet, gs)),
                        ...(mobile(device) && decodeStyle(ps.mobile, gs)),
                    }}
                >
                    {input.breadcrumbItems.map((item, index) => {
                        return (
                            <Fragment key={index}>
                                <span style={linkStyle}>{item.label}</span>
                                {index < input.breadcrumbItems.length - 1 && (
                                    <span>{input.divider}</span>
                                )}
                            </Fragment>
                        );
                    })}
                </div>
            )}
        </div>
    );
}

export default Breadcrumb;
